import React from 'react';
import { connectStats, ClearRefinements } from 'react-instantsearch-dom';

import Button from '3-components/Buttons/Button';

import CustomRefinementList from '4-sections/AlgoliaSearch/widgets/CustomRefinementList';
import CustomToggleSoldRefinementList from '4-sections/AlgoliaSearch/widgets/CustomToggleSoldRefinementList';
import { CustomAllRefinementCount } from '4-sections/AlgoliaSearch/widgets/CustomRefinementCount';

const LocationListingFilter = ({
    nbHits,
    showFilter,
    facets,
    openFilterModal,
    refinementListState,
    showRecentlySoldFilter,
    soldToggleValue,
    soldToggleHandle
}) => {
    const renderFilter = showFilter && nbHits > 0;

    const changeHandle = e => {
        // console.info('changed to', e.target.checked);
        // console.info('setRefinementListState', setRefinementListState);
        // const nowTimestamp = Date.now() / 1000;
        // const today = new Date();
        // const priorDate = (new Date(new Date().setDate(today.getDate() - 30))).getTime() / 1000;
        // console.info('priorDate', priorDate.getTime());
        // if (setRefinementListState) {
        //     if (e.target.checked) {
        //         // refinementListState.sold_date_timestamp = `> ${priorDate}`;
        //         setRefinementListState({
        //             ...refinementListState,
        //             filters: 'sold_date_timestamp > 1684127555.215'
        //             // filters: `sold_date_timestamp > 1684127555.215 > ${priorDate}`
        //         });
        //     } else {
        //         // refinementListState.sold_date_timestamp = null;
        //         setRefinementListState({
        //             ...refinementListState,
        //             filters: null
        //         });
        //     }
        // }
        if (soldToggleHandle) {
            soldToggleHandle(e.target.checked);
            // if (e.target.checked) {
            //     // refinementListState.sold_date_timestamp = `> ${priorDate}`;
            //     setRefinementListState({
            //         ...refinementListState,
            //         filters: 'sold_date_timestamp > 1684127555.215'
            //         // filters: `sold_date_timestamp > 1684127555.215 > ${priorDate}`
            //     });
            // } else {
            //     // refinementListState.sold_date_timestamp = null;
            //     setRefinementListState({
            //         ...refinementListState,
            //         filters: null
            //     });
            // }
        }
    };

    return (
        <>
            <div className={`hr-separator${renderFilter ? '' : ' extra-bottom-space'}`} />
            {renderFilter && (
                <>
                    <div className="filters-container tablet-filter">
                        <div className="filter-group-label">
                            <span>Filter by</span>
                            <ClearRefinements translations={{ reset: 'Clear filters' }} />
                        </div>
                        {facets && facets.length > 0 && facets.map(facet => (
                            <CustomRefinementList
                                filterAttribute={facet.attribute}
                                defaultRefinement={(refinementListState && refinementListState[facet.attribute])}
                                label={facet.label}
                                key={facet.attribute}
                            />
                        ))}
                        {showRecentlySoldFilter && (
                            <CustomToggleSoldRefinementList
                                label="Show recently sold"
                                defaultValue={soldToggleValue}
                                onChange={changeHandle}
                            />
                        )}
                    </div>
                    <Button
                        btnText={<CustomAllRefinementCount labelAttribute="Filter" />}
                        prefixIcon="filter"
                        onclick={openFilterModal}
                        btnCustomClass="mobile-filter-toggle-button"
                    />
                </>
            )}
        </>
    );
};

const CustomStats = connectStats(LocationListingFilter);

export default CustomStats;
